import whiteLogo from "../assets/img/tomov-logo-white.png";
import blackLogo from "../assets/img/tomov-logo-black.png";
import ImageWrapper from "./ImageWrapper";
import Button from "./Button";
import { useEffect, useState } from "react";
import { navbar } from "../utils/menus";
import Icon from "./Icon";
import SidebarLink from "../components/SidebarLink";

function Navbar() {
  const [open, toggleSidebar] = useState(false);
  const [scrollY, setScrollY] = useState(window.scrollY > 100);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    const handleScroll = () => {
            setScrollY(window.scrollY > 100);
        };
        
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
  }, [open]);

  // useEffect(() => {
  //     // Toggle body scroll lock when menu is open
  //     if (open) {
  //         document.body.classList.add('overflow-hidden');
  //     } else {
  //         document.body.classList.remove('overflow-hidden');
  //     }
  // }, [open]);

  return (
    // SECONDARY NAV

    <div
      className={`
      fixed top-0 z-[99] w-full pb-4
      ${open ? "h-screen overflow-y-auto" : ""}
    `}
    >
      <div className="bg-[#f1f1f1] py-2 flex justify-center lg:justify-end items-center">
        <div className="flex flex-col lg:flex-row items-start page__width lg:items-center text-text justify-end gap-4 text-sm text-text">
          <a
            href="https://instagram.com/"
            className="flex items-center gap-1 hover:underline"
            target="_blank"
          >
            <Icon name="address" className="w-4 h-4" />
            Opalchenska St 94, Banishora, 1233 Sofia
          </a>
          <div className="flex gap-4 lg:gap-0 w-full lg:w-auto">
            <a
              href="tel:088 528 5757"
              className="flex items-center gap-1 hover:underline"
              target="_blank"
            >
              <Icon name="phone" className="w-4 h-4" />
              088 528 5757
            </a>
            <div className="flex gap-2 lg:ml-4">
              <a
                href="https://www.facebook.com/profile.php?id=100033197096470"
                target="_blank"
              >
                <Icon name="facebook" className="w-4 h-4 hover:text-brand" />
              </a>
              <a href="https://instagram.com/" target="_blank">
                <Icon name="instagram" className="w-4 h-4 hover:text-brand" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN NAV / HEADER */}

      <div
        className={`${
          open ? "bg-white" : scrollY ? "bg-white shadow-nav" : "bg-none"
        } z-[99] w-full py-4`}
      >
        <div className="page__width relative flex items-center justify-between">
          <div className="flex items-center gap-8">
            <a href="/">
              <ImageWrapper
                src={open ? blackLogo : scrollY ? blackLogo : whiteLogo}
                alt="Logo"
                className="w-32 py-2"
              />
            </a>
            <div className="hidden lg:flex items-center gap-8">
              {navbar.map((link, i) => {
                return (
                  <>
                    {link.submenu ? (
                      <SidebarLink
                        key={i}
                        sublinks={link.submenu}
                        scrollY={scrollY}
                        href={link.href}
                      >
                        {link.label}
                      </SidebarLink>
                    ) : (
                      <a
                        key={i}
                        href={link.href}
                        className={`navlink relative block text-sm ${
                          scrollY ? "text-black" : "text-white"
                        }`}
                      >
                        {link.label}
                      </a>
                    )}
                  </>
                );
              })}
            </div>
          </div>
          <Button type="cta-border" className="hidden lg:block" href="/contact">
            Свържете се с нас
          </Button>
          <button
            className="lg:hidden"
            onClick={() => {
              toggleSidebar(!open);
            }}
          >
            {open ? (
              <Icon name="x-icon" className="w-6 h-6 mr-8 text-black" />
            ) : (
              <Icon
                name="burger"
                className={`w-6 h-6 mr-8 ${
                  scrollY ? "text-black" : "text-white"
                }`}
              />
            )}
          </button>
        </div>

        {/* MOBILE NAV */}

        <div
          className={`
      top-full duration-200 transition-all bg-white w-full z-[99] lg:hidden
      ${open ? "pb-8 shadow-lg" : "max-h-0 overflow-hidden"}
    `}
        >
          <div className="flex min-h-full h-full flex-col items-start pt-8">
            {navbar.map((link, i) => {
              return (
                <>
                  {link.submenu ? (
                    <SidebarLink
                      key={i}
                      sublinks={link.submenu}
                      href={link.href}
                    >
                      {link.label}
                    </SidebarLink>
                  ) : (
                    <a
                      key={i}
                      href={link.href}
                      className="px-[7.5%] block w-full text-base text-black py-4 transition-all duration-200"
                    >
                      {link.label}
                    </a>
                  )}
                </>
              );
            })}
            <Button
              type="cta-border"
              className="w-[85%] mx-auto flex items-center justify-center"
              href="/contact"
            >
              Свържете се с нас
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
